/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import IFlujos from '../../negocioRefactor/entidades/repositorio/IFlujo';

export default class ModeloFlujos {
    public consultarFlujos() {
        return manejadorRest<IRespuesta<IFlujos>>(() => negocio.get('Flujo/ConsultarListaFlujo'));
    }
    public crearFlujos(flujos: IFlujos) {
        return manejadorRest<IRespuesta<IFlujos>>(() => negocio.post('Flujo/GuardarFlujo', flujos));
    }
    public editarFlujos(flujos: IFlujos) {
        return manejadorRest<IRespuesta<IFlujos>>(() => negocio.put('Flujo/EditarFlujo', flujos));
    }
    public eliminarFlujos(flujos: IFlujos) {
        return manejadorRest<IRespuesta<IFlujos>>(() => negocio.delete('Flujo/EliminarFlujo', flujos));
    }
    public consultarFlujosPorFiltro(flujos: Partial<IFlujos>) {
        return manejadorRest<IRespuesta<IFlujos>>(() => negocio.post('Flujo/ConsultarListaFlujoPorFiltro', flujos));
    }
}
